import Head from 'next/head'
import Image from "next/legacy/image";
import styles from "../styles/pages/Experiences.module.scss"
import Link from 'next/link'
import Topbanner from '../components/Topbanner/Topbanner';
import Slider from "react-slick";
import FAQs from '../components/Faqs';
import { useRouter } from 'next/router';
import { useEffect, useState } from 'react';
import { addDays, differenceInDays } from 'date-fns';
import moment from "moment";

export default function Experiences() {
    const settings = {
        dots: true,
        infinite: true,
        arrows: false,
        speed: 500,
        autoplay: true,
        autoplaySpeed: 3000,
        slidesToShow: 3,
        slidesToScroll: 1,
        responsive: [
            {
                breakpoint: 1440,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1,
                    dots: true,
                },
            },
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                    dots: true,
                },
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                    initialSlide: 2,
                },
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                },
            },
        ],
    };

    const experiences = [
        {
            title: "Mahasu Peak",
            description:
                "Mahasu Peak is the highest point in Kufri, offering breathtaking views of the Himalayas. The trek to the peak is an adventure, surrounded by lush pine forests. It’s an ideal spot for photography and nature lovers. The panoramic vistas are especially stunning at sunrise and sunset. You can also spot various bird species here, making it a great place for birdwatching. A visit to Mahasu Peak is a must for anyone seeking natural beauty.",
            image: "/images/experience/mahasu.png",
            alt: "Mahashu Peak",
            textFirst: false,
        },
        {
            title: "The Himalayan Nature Park",
            description:
                "The Himalayan Nature Park is a peaceful retreat that showcases the region's diverse flora and fauna. It features beautiful walking trails where you can enjoy the serene environment and spot native animals. The park is home to various species of trees, plants, and wildlife, making it perfect for nature walks. You can also learn about the local ecosystem through informative displays. A visit here allows you to connect with nature and enjoy the tranquil surroundings.",
            image: "/images/experience/himalayan-nature-park-kufri.png",
            alt: "The Himalayan Nature Park",
            textFirst: true,
        },
        {
            title: "Fagu",
            description:
                "Fagu is a charming village near Kufri known for its stunning apple orchards and picturesque landscapes. It offers a tranquil escape from the bustling city life. The views of snow-capped mountains and lush greenery are breathtaking, especially during the autumn months when the leaves change colors. Fagu is a great spot for picnics and leisurely walks. Visitors can also explore the local culture and enjoy the hospitality of the villagers while savoring fresh apple produce.",
            image: "/images/experience/fagu.png",
            alt: "Fagu",
            textFirst: false,
        },
        // {
        //     title: "Kufri Zoo",
        //     description:
        //         "Kufri Zoo is a must-visit for animal lovers and families. It houses various species, including the rare Himalayan Monal, along with other animals like bears and deer. The zoo is well-maintained and provides a natural habitat for the animals, allowing visitors to learn about their behaviors and conservation efforts. Kids will particularly enjoy seeing the animals up close and engaging with educational exhibits. A trip to Kufri Zoo is both fun and informative!",
        //     image: "/images/experience/kufri.png",
        //     alt: "Kufri Zoo",
        //     textFirst: true,
        // },
        {
            title: "Indira Gandhi Tourist Park",
            description:
                "Indira Gandhi Tourist Park is a popular picnic spot located near Kufri. Known for its serene atmosphere and lush greenery, this park is a great place to unwind and enjoy the natural surroundings. It offers expansive lawns, shaded areas, and stunning views of the surrounding mountains. Families and groups of friends often visit the park to relax, take leisurely walks, or enjoy a picnic amidst nature. It’s an ideal destination for those looking for peace and scenic beauty.                ",
            image: "/images/experience/indira-gandhi-tourist-park.png",
            alt: "Indira Gandhi Tourist Park",
            textFirst: true,
        },
        {
            title: "Green Valley",
            description:
                "Green Valley is a breathtaking viewpoint located on the way to Kufri, offering stunning panoramic views of the surrounding hills and dense pine forests. As the name suggests, the valley is covered with lush greenery, making it an ideal stop for photography enthusiasts and nature lovers. The fresh air and scenic beauty are perfect for a quick break during your journey to Kufri. Green Valley is also home to various wildlife species, which can occasionally be spotted in the distance.",
            image: "/images/experience/green-valley-kufri.jpg",
            alt: "Green Valley",
            textFirst: false,
        },

    ];

    const thingsToDo = [
        {
            icon: '/icons/kufri-fun-world.svg',
            title: 'Visit Adventure Resorts'
        },
        {
            icon: '/icons/snow-kingdom.svg',
            title: 'Enjoy Snow Any-month at Snow Kingdom Kufri'
        },
        {
            icon: '/icons/skiing-in-winter.svg',
            title: 'Enjoy Skiing in Winter'
        },
        {
            icon: '/icons/horse-riding.svg',
            title: 'Horse Riding'
        },
        {
            icon: '/icons/national-park.svg',
            title: 'Visit the Himalayan Nature Park'
        },
        {
            icon: '/icons/yak-ride.svg',
            title: 'Yak Ride'
        },
        {
            icon: '/icons/mahasu-peak.svg',
            title: 'Visit Mahasu Peak'
        },
        {
            icon: '/icons/tobagganing.svg',
            title: 'Enjoy Tobogganing in Winter'
        },
        {
            icon: '/icons/kufri-zoo.svg',
            title: 'Visit Kufri Zoo'
        },
    ]

    const activities = [
        {
            title: "Sky Swinger",
            bgImage: "/images/sky-swinger.png",
            description: "Sky Swinger is a new way to experience the sky. As an aerial playground, Sky Swinger offers thrilling opportunities for people to experience the rush of adrenaline."
        },
        {
            title: "Go Kart",
            bgImage: " /images/karting-attra.png",
            description: "Go-karts are the ultimate way to channel your inner child. We know you've got the skills and the moves, but it's time to get out of your comfort zone with Go Karting."
        },
        {
            title: "Zip Line",
            bgImage: "/images/zip-line.webp",
            description: "Zipline offers a unique, exhilarating experience you'll never forget. Our expert instructors help participants feel secure during the flight."
        },
        {
            title: "Bungee Injection",
            bgImage: "/images/bungee.png",
            description: " Bungee Injection is a new adventure activity that combines one of the most adrenaline-pumping experiences in the world with a fun, friendly environment."
        },
        {
            title: "Indoor activities",
            bgImage: "/images/outdoor.jpg",
            description: "At Adventure Resorts, we have a wide variety of indoor activities to keep you entertained. We have dashing cars, haunted house, 5D theater and much more. You will never feel bored."
        },
    ];

    const faqsData = [
        {
            accordionQuestion: "What are the top attractions in Kufri?",
            accordionAnswer: "Kufri offers several attractions, including Mahasu Peak, Snow Kingdom Kufri, and Kufri Zoo. Each location provides unique experiences, from stunning views to exciting activities.",
            id: 1
        },
        {
            accordionQuestion: "How do I reach Kufri from Shimla?",
            accordionAnswer: "Kufri is approximately 16 kilometers from Shimla and can be reached by taxi or bus in about 30 minutes. The scenic drive through the hills is enjoyable and a great way to start your adventure.",
            id: 2
        },
        {
            accordionQuestion: "What outdoor activities are available in Kufri?",
            accordionAnswer: "Kufri is known for its outdoor adventures, such as trekking, zip-lining, and skiing in winter. Adventure Resorts Kufri is an excellent place to try activities like bungee ejection, sky swinger, Rope Course, Go-Karting, and such types of activities.",
            id: 3
        },
        {
            accordionQuestion: "Can I find accommodation near popular attractions in Kufri?",
            accordionAnswer: "Yes, The Twin Towers Hotel is conveniently located near major attractions in Kufri, making it an ideal place to stay while exploring the area. The hotel offers comfortable rooms and easy access to local sights.",
            id: 4
        },
        {
            accordionQuestion: "What is the best time to visit Kufri?",
            accordionAnswer: "Kufri is a year-round destination. The best time to visit depends on your preferences: winter for snow activities, summer for pleasant weather, and autumn for beautiful landscapes.",
            id: 5
        }
    ];

    const router = useRouter();
    const [loader, setLoader] = useState(false);
    const [noOfNights, setNoOfNights] = useState(router.query.npOfNights || 1);
    const [startDate, setStartDate] = useState(new Date());
    const [endDate, setEndDate] = useState(() => {
        const tomorrow = addDays(new Date(), 1);
        return tomorrow;
    });

    const [checkin, setCheckin] = useState({
        day: router.query.checkinDay || "",
        month: router.query.checkinMonth || "",
        year: router.query.checkinYear || "",
    });

    const [checkout, setCheckout] = useState({
        day: router.query.checkoutDay || "",
        month: router.query.checkoutMonth || "",
        year: router.query.checkoutYear || "",
    });

    useEffect(() => {
        const updateDateState = (date, setStateFunction) => {
            if (date !== null) {
                const day = date.getDate();
                const month = (date.getMonth() + 1).toString().padStart(2, "0");
                const year = date.getFullYear();
                setStateFunction({ day, month, year });
            }
        };

        updateDateState(startDate, setCheckin);
        updateDateState(endDate, setCheckout);

        const nights = moment(endDate).diff(moment(startDate), 'days');
        setNoOfNights(nights > 0 ? nights : 1);
    }, [startDate, endDate]);

    useEffect(() => {
        const nights = differenceInDays(endDate, startDate);
        setNoOfNights(nights);
    }, [startDate, endDate]);

    const formated_start_date = moment(startDate).format("YYYY-MM-DD");
    const formated_end_date = moment(endDate).format("YYYY-MM-DD");

    const handleSubmit = async (event, hotelId) => {
        event.preventDefault();

        setLoader(true);

        try {
            await router.push(
                `/searchresults/?hotelID=${hotelId}&checkinDay=${checkin.day}&checkinMonth=${checkin.month}&checkinYear=${checkin.year}&checkoutDay=${checkout.day}&checkoutMonth=${checkout.month}&checkoutYear=${checkout.year}&room=1&adult=2&children=0&checkIn=${formated_start_date}&checkOut=${formated_end_date}&noOfNights=${noOfNights}`,
                undefined,
                { shallow: false }
            );

        } catch (error) {
            console.error("Error fetching data:", error);
        } finally {
            setLoader(false);
        }
    };


    return (
        <>
            <Head>
                <title>Things to Do and Experiences in Kufri Shimla</title>
                <meta name="description" content="Things to Do and Experiences Kufri Shimla, Live Barbeque, Bonfire, Jungle Walk, Jungle Safari, | The Twin Towers Hotel in Shimla" />
                <link rel="icon" href="/favicon.svg" />
                <link rel="canonical" href="https://www.hoteltwintowers.com/experiences" />
            </Head>
            {/* <Topbanner bgImage={"/images/activities-banner.png"} title={"Experiences"} /> */}

            <section className={styles.single_blog_top_banner}>
            </section>

            <section className={`${styles.experiences_sec} common_padding`}>
                <div className="container">
                    <h1 className={`${styles.experience_page_heading} mb-4`}>PLACES TO VISIT IN KUFRI</h1>
                    {experiences && experiences?.map((experience, index) => (
                        <div key={index} className={`${styles.experiences_main} row`}>
                            {experience.textFirst ? (
                                <>
                                    <div className={`${styles.experiences_text}`}>
                                        <div className="common_title">
                                            <h2>{index + 1}. {experience.title}</h2>
                                            <p>{experience.description}</p>
                                        </div>
                                    </div>
                                    <div
                                        className={`${styles.experiences_image} col-md-4 first-order-mobile`}
                                    >
                                        <img src={experience.image} alt={experience.alt} />
                                    </div>
                                </>
                            ) : (
                                <>
                                    <div className={`${styles.experiences_image}`}>
                                        <img src={experience.image} alt={experience.alt} />
                                    </div>
                                    <div className={`${styles.experiences_text}`}>
                                        <div className="common_title">
                                            <h2>{index + 1}. {experience.title}</h2>
                                            <p>{experience.description}</p>
                                        </div>
                                    </div>
                                </>
                            )}
                        </div>
                    ))}
                </div>
            </section>


            <section className={`${styles.adventure_snow_kingdom_sec}`}>
                <div className="container">
                    <h4 className={styles.other_places_heading}>there are more places to visit in shimla</h4>
                    <div className={styles.adventure_snow_kingdom_sec_row}>
                        <div className={styles.adventure_snow_kingdom_sec_row_text}>
                            <h4>Adventure Resorts</h4>
                            <h3>A Complete Tourist Destination</h3>
                            <p className={styles.para_cont}>Adventure Resorts Kufri is a must-visit destination for thrill-seekers and nature lovers. This resort offers a variety of outdoor activities such as zip-line, bungee ejection, sky swinger, and go-karting. Whether you’re traveling solo, with friends, or with family, these activities promise an adrenaline-filled adventure while allowing you to appreciate the stunning natural beauty around you. With comfortable accommodations and delightful dining options, Adventure Resorts Kufri is perfect for creating unforgettable memories in the heart of the mountains.</p>
                            <div className={styles.highlights}>
                                <div className={styles.highlight_item}>
                                    <div className={styles.highlight_item_icon}>
                                        <Image src='/icons/adventure-activities.svg' height={35} width={35} alt='Adventure Activities'></Image>
                                    </div>
                                    <p>Adventure Activities</p>
                                </div>
                                <div className={styles.highlight_item}>
                                    <div className={styles.highlight_item_icon}>
                                        <Image src='/icons/safe-adventure.svg' height={35} width={35} alt='Safe Adventure Spot'></Image>
                                    </div>
                                    <p>Safe Adventure Spot</p>
                                </div>
                                <div className={styles.highlight_item}>
                                    <div className={styles.highlight_item_icon}>
                                        <Image src='/icons/perfect-family.svg' height={35} width={35} alt='Perfect for Families'></Image>
                                    </div>
                                    <p>Perfect for Families</p>
                                </div>
                            </div>
                            <Link href='https://www.adventureresortkufri.com/' target="_blank" rel='noopener noreferrer' className='common_btn'>Know More</Link>
                        </div>
                        <div className={`${styles.adventure_snow_kingdom_sec_row_image} ${styles.mobile_first}`}>
                            <img src='/images/experience-adventure-resort.png' alt='adventure-resort' />
                        </div>
                    </div>
                </div>
            </section>

            <section className={`${styles.adventure_snow_kingdom_sec} common_padding`}>
                <div className="container">
                    <div className={styles.adventure_snow_kingdom_sec_row}>
                        <div className={styles.adventure_snow_kingdom_sec_row_image}>
                            <img src='/images/experience-snow-kingdom.png' alt='Snow kingdom kufri' />
                        </div>
                        <div className={styles.adventure_snow_kingdom_sec_row_text}>
                            <h4>Snow kingdom kufri</h4>
                            <h3>Your Snowy Escape in the Heart of Himachal</h3>
                            <p className={styles.para_cont}>Snow Kingdom Kufri is a magical destination for winter lovers, situated at a height of 8,800 feet. As the largest snow park in Himachal Pradesh, it spans over 12,000 square feet and offers a unique experience for visitors. You can enjoy thrilling snowball fights, snow tubing, and sledding, all while surrounded by towering snow structures that reach up to 30 feet. This snow paradise ensures that the fun continues year-round, making it a favorite spot for families and winter sports enthusiasts alike.</p>
                            <div className={styles.highlights}>
                                <div className={styles.highlight_item}>
                                    <div className={styles.highlight_item_icon}>
                                        <Image src='/icons/yearround-destination.svg' height={35} width={35} alt='Year Ruund Desination'></Image>
                                    </div>
                                    <p>Year-Round Destination</p>
                                </div>
                                <div className={styles.highlight_item}>
                                    <div className={styles.highlight_item_icon}>
                                        <Image src='/icons/child-friendly.svg' height={35} width={35} alt='Child Friendly'></Image>
                                    </div>
                                    <p>Child-Friendly</p>
                                </div>
                                <div className={styles.highlight_item}>
                                    <div className={styles.highlight_item_icon}>
                                        <Image src='/icons/snow-paradise.svg' height={35} width={35} alt='Snow Paradise'></Image>
                                    </div>
                                    <p>Snow Paradise</p>
                                </div>
                            </div>
                            <Link href='https://www.snowkingdomkufri.com/' target="_blank" rel='noopener noreferrer' className='common_btn'>Know More</Link>
                        </div>
                    </div>
                </div>
            </section>

            <section className={`${styles.things_to_do}`}>
                <div className='container'>
                    <h2 className={`${styles.experience_page_heading} mb-4`}>THINGS TO DO IN KUFRI</h2>
                    <div className={styles.things_to_do_main}>
                        {thingsToDo && thingsToDo.map((item, index) => (
                            <div className={styles.things_to_do_item} key={index}>
                                <div className={styles.things_to_do_item_icon}>
                                    <Image src={item.icon} width={55} height={55} alt={item.title} />
                                </div>
                                <div className={styles.things_to_do_item_text}>
                                    <h4>{item.title}</h4>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            <div className='common_padding'>
                <div className="container">
                    <h2 className={`${styles.experience_page_heading} mb-2`}>FAQs</h2>
                    <FAQs faqsData={faqsData} />
                </div>
            </div>
            <div className={styles.blog_footer}>
                <div className={styles.blog_footer_content}>
                    <h4>Your Perfect Stay Awaits</h4>
                    {/* <Link href='https://thetwintowers.bookingjini.com/property' target='_blank' > */}
                    <button className={styles.blog_page_btn} onClick={(event) => handleSubmit(event, 17)}>Book Now</button>
                    {/* </Link> */}
                </div>
            </div>
            {/* <section className={`${styles.activities_sec} common_padding pb-0`} id="activity_scroll">
                <div className='container'>
                    <div className='common_title text-center'>
                        <h4>Enjoy The More Thrill at</h4>
                        <h2>adventure resorts</h2>
                    </div>
                    <div className={styles.activities_slider}>
                        <Slider {...settings} className="activity_slider">
                            {activities.map((activity, index) => (
                                <div className={styles.activity_child} key={index}>
                                    <div className={styles.activity_bg_image} style={{ backgroundImage: `url(${activity.bgImage})` }}>
                                        <span>{activity.title}</span>
                                        <div className={styles.activity_overlay}>
                                            <p>{activity.description}</p>
                                            <p>Click Here to: <Link href="/contact-us">Enquire Now</Link></p>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </Slider>
                        <div className={styles.explore_btn}>
                            <p>Get exclusive 10% OFF on all adventure activities at Adventure Resorts, <strong><Link href="/contact-us">Contact Now</Link></strong></p>
                        </div>
                    </div>
                </div>
            </section> */}
        </>
    )
}

// {
//     title: "Jungle Walk",
//     description:
//         "Nothing beats an early morning forest walk. It is worth going for an early morning jungle walk - the air is so cool and refreshing. A hamper breakfast in the middle of the jungle is indeed no match. It is about a 5 km walk, passing through the thick cedar jungle of Kufri.",
//     image: "/images/jungle-walk.png",
//     alt: "Jungle Walk Image",
//     textFirst: false,
// },
// {
//     title: "Bonfire",
//     description:
//         "Gather around our bonfire pit with your friends and family to enjoy the warmth and ambiance of the flames. Roast marshmallows, make s'mores, and snuggle up with blankets as you watch the stars above. The crackling sounds of the fire and the warmth of the bonfire will create lasting memories with your loved ones.",
//     image: "/images/bonfire.png",
//     alt: "Bonfire Image",
//     textFirst: true,
// },
// {
//     title: "Live Barbeque",
//     description:
//         "To enjoy the luxury of grilling, simply select items from our menu. Our chef will grill the marinated items of your choice and you can enjoy your party or family dine-in with smoky flavors.",
//     image: "/images/barbeque.png",
//     alt: "Barbeque Image",
//     textFirst: false,
// },
// {
//     title: "Jungle Safari",
//     description:
//         "Jeep Safari is one of the best ways to explore unexplored places. Off-road safaris provide you with a unique and exciting experience. It takes you through adventurous and uncommon routes where you can observe rare species of flora and fauna. On our Safari tour, the road passes through dense pine forests, with trees soaring up 20 meters. Road hazards include flocks of sheep, traditionally dressed village women and men, and wild animals, etc. Through the 15 km off-road journey, you will have a very different day out with the nature of the jungle.",
//     image: "/images/jungle-safari.png",
//     alt: "Jungle Safari Image",
//     textFirst: true,
// },